// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-action-template/src/index.tsx

// TODO: Check if the icon is alined properly.
// If it is not: Replace/extend defaultAlignedActionIconGroupProps to make it look right.
// https://stash.int.klarna.net/projects/UI/repos/bubble-ui/pull-requests/121/overview?commentId=2244923
import baseIcon, { defaultAlignedActionIconGroupProps } from '@bubble-ui/temp-icon-base';
var ActionIconStarPath = 'm6.479 8.639 1.43.432-.295-1.322c-.01-.34.095-.678.295-.954l.8-1.195-1.15-.266c-.403-.121-.694-.341-.888-.64l-.672-1.031-.674 1.033c-.19.295-.481.516-.818.62l-1.22.283.823 1.226c.178.246.283.584.273.924l-.027.207-.27 1.115 1.454-.44c.264-.1.615-.104.939.008Zm4.194 3.354L5.995 10.58l-4.671 1.412 1.017-4.215L.01 4.305l3.747-.866L5.999 0l2.243 3.442 3.745.863-2.331 3.474 1.017 4.214Z';
var ActionIconStar = baseIcon('ActionIconStar', {
  groupProps: defaultAlignedActionIconGroupProps,
  getPath: () => ActionIconStarPath
});
export default ActionIconStar;
//# sourceMappingURL=index.js.map